import Icon from '../components/Icon.vue'

Icon.register({
  'car-battery': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M480 128H448V80C448 71.2 440.8 64 432 64H336C327.2 64 320 71.2 320 80V128H192V80C192 71.2 184.8 64 176 64H80C71.2 64 64 71.2 64 80V128H32C14.3 128 0 142.3 0 160V416C0 433.7 14.3 448 32 448H480C497.7 448 512 433.7 512 416V160C512 142.3 497.7 128 480 128zM192 264C192 268.4 188.4 272 184 272H72C67.6 272 64 268.4 64 264V248C64 243.6 67.6 240 72 240H184C188.4 240 192 243.6 192 248V264zM448 264C448 268.4 444.4 272 440 272H400V312C400 316.4 396.4 320 392 320H376C371.6 320 368 316.4 368 312V272H328C323.6 272 320 268.4 320 264V248C320 243.6 323.6 240 328 240H368V200C368 195.6 371.6 192 376 192H392C396.4 192 400 195.6 400 200V240H440C444.4 240 448 243.6 448 248V264z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/car-battery.js
// module id = 2sPp
// module chunks = 144